/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum DataModelDataMigrationType {
    MOVE_BY = 'moveBy',
    JOB_WEIGHTED = 'jobWeighted',
    EMPLOYEE_WEIGHTED = 'employeeWeighted',
}
